"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
exports.unstyledLoader = unstyledLoader;
const React = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const pulse = (0, styled_components_1.keyframes) `
  0% {
    -ms-transform: scale(2);
    -moz-transform: scale(2);
    -webkit-transform: scale(2);
    -o-transform: scale(2);
    transform: scale(2);
  }
  90% {
    -ms-transform: scale(1);
    -moz-transform: scale(1);
    -webkit-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
  100% {
    -ms-transform: scale(1);
    -moz-transform: scale(1);
    -webkit-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
`;
function unstyledLoader(props) {
    return (React.createElement("div", Object.assign({}, props),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null)));
}
exports.Loader = (0, styled_components_1.default)(unstyledLoader) `
  transform: scale(0.3);
  background: none;
  position: relative;
  width: 200px;
  height: 200px;
  margin: auto;

  top: 0;

  > div {
    position: absolute;
    width: 40px;
    height: 120px;
    top: 40px;
    left: 20px;
    background: #3769c8;
    opacity: 0.6;
    animation: ${pulse} 1s cubic-bezier(0.01, 0.73, 0.28, 0.93) infinite;
  }
  > div:nth-of-type(2) {
    left: 80px;
    opacity: 0.8;
    animation-delay: 0.1s;
  }

  > div:nth-of-type(3) {
    left: 140px;
    opacity: 0.9;
    animation-delay: 0.2s;
  }
`;
//# sourceMappingURL=loader.js.map